import { render, staticRenderFns } from "./CreatePlacementType.vue?vue&type=template&id=15982f20&"
import script from "./CreatePlacementType.vue?vue&type=script&lang=js&"
export * from "./CreatePlacementType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports